import React, {useEffect, useState} from "react";
import {getItems, getRaw} from "../../../utils/communication";
import isAnError, {AnError} from "../../../model/misc";
import RecipeCard from "../../../components/cooking/recipe/recipe-card";
import Pagination from "../../../components/pagination";
import parseAnError from "../../../model/misc";
import ErrorDisplay from "../../../components/error-display";

export default function RecipeHome() {
    const [count, setCount] = useState<number>(1),
        [recipes, setRecipes] = useState<Recipe[]>([]),
        [offset, setOffset] = useState<number>(1),
        [error, setError] = useState<string | null>(null);

    useEffect(() => {
        document.title = "Recipes - Hoarfroster";

        (async () => {
            let response = await getRaw("/cooking/recipe/count");

            if (response.code !== 200) {
                setError(parseAnError(response.data).message);
            } else {
                setCount(Math.ceil((response.data.count as number) / 10));
            }
        })();
    }, []);

    useEffect(() => {
        let _ = getRecipes((offset - 1) * 10);
    }, [offset, count]);

    const getRecipes = async (offset: number) => {
        let response = await getItems<Recipe>("/cooking/recipe/all?offset=" + offset + "&limit=10");

        if (response.code !== 200) {
            setError(parseAnError(response.data).message);
        } else {
            setRecipes(response.data as Recipe[]);
        }
    }

    return (
        <main>
            <div className="container">
                <div className="content space-y-4">
                    <h1>Recipes</h1>

                    {recipes.map((recipe, index) => (
                        <RecipeCard recipe={recipe} needsSeparator={index !== recipes.length - 1} />
                    ))}

                    <Pagination currentPage={offset} totalPages={count} onPageChange={setOffset}/>

                    <ErrorDisplay error={error} />
                </div>

                <div className="sidebar space-y-2">
                    <h2>Tips</h2>
                    <p>如果没有登录，你可能无法看得到图片。</p>
                </div>
            </div>
        </main>
    );
}